<template>
  <el-dialog
    title="提示信息"
    :visible.sync="dialogLoading"
    top="20%"
    width="420px"
    :lock-scroll=false
    :show-close=false
    :close-on-click-modal=false
    :close-on-press-escape=false
    custom-class="dialog">
    <img style="margin-left: 30px;vertical-align: middle" src="../../assets/imgs/loading.gif" alt="">
    <span class="z-font-size-14 z-margin-left-5-precent">加载中，请稍后...</span>
    <span slot="footer" class="dialog-footer">
          </span>
  </el-dialog>
</template>

<script>
    export default {
      props:{
        dialogLoading: { type: Boolean, default:false },
      },
      data() {
        return {

        }
      },
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/commons/XdialogLoading.vue